import styled from "styled-components";
import React, { useEffect } from "react";
// import ScrollMagic from "scrollmagic";
// import { TimelineMax } from "gsap/TweenMax";

import Header from "../components/Header";
import Layout from "../components/Layout/Layout";

import "./index.css";

import Base from "../components/Layout/Base";
import Landing from "../components/Landings/Landing";
import Counter from "../components/Counters/Counter";
import PressSlider from "../components/PressCards";
import Partner from "../components/Partner";
import StudentSlider from "../components/StudentSlider";
import Trusts from "../components/Trusts/Trusts";
import CTA from "../components/CTA";
import Secondary from "../components/Buttons/Secondary-Button";
import UseCases from "../components/UseCases/UseCases";
import Workers from "../components/Workers/Workers";
import Card from "../components/StudentCard";

if (typeof window !== "undefined") {
  require("materialize-css");
}

const Title = styled.h1`
  font-weight: 600;
  color: #223461;
  font-size: 30px;
  margin-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 20px;
  line-height: 1.5;
`;

const SubTitle = styled.div`
  font-size: 18px;
  text-align: center;
  padding-bottom: 20px;
  padding-left: 100px;
  padding-right: 100px;
  color: #667988;
  @media only screen and (max-width: 700px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

const Index = () => {
  // useEffect(() => {
  //   const controller = new ScrollMagic.Controller();

  //   const nums = [1, 2, 3, 4, 5, 6];

  //   nums.map(num => {
  //     new ScrollMagic.Scene({
  //       triggerElement: `#trigger${num}`,
  //       triggerHook: 0.9,
  //       offset: 50,
  //       reverse: false
  //     })
  //       .setClassToggle(`#reveal${num}`, "visible") // add class to reveal
  //       .addIndicators() // add indicators (requires plugin)
  //       .addTo(controller);
  //   });

  //   var wipeAnimation = new TimelineMax({repeat:"repeat",repeatDelay:1});
  //   // animate to second panel

  //   wipeAnimation
  //     .to("#slideContainer", 0.5, { z: -150 }) // move back in 3D space
  //     .to("#slideContainer", 1, { x: "-25%" }) // move in to first panel
  //     .to("#slideContainer", 0.5, { z: 0 }) // move back to origin in 3D space
  //     // animate to third panel
  //     .to("#slideContainer", 0.5, { z: -150, delay: 1 })
  //     .to("#slideContainer", 1, { x: "-50%" })
  //     .to("#slideContainer", 0.5, { z: 0 })

  //     .to("#slideContainer", 0.5, { z: -150, delay: 1 })
  //     .to("#slideContainer", 1, { x: "0%" })
  //     .to("#slideContainer", 0.5, { z: 0 });

  //   new ScrollMagic.Scene({
  //     triggerElement: "#pinContainer",
  //     triggerHook: "onLeave",
  //     duration: "500%",
  //     reverse: true
  //   })
  //     .setPin("#pinContainer")
  //     .setTween(wipeAnimation)
  //     .addIndicators() // add indicators (requires plugin)
  //     .addTo(controller);
  // }, []);
  return (
    <Base>
      <Header />
      <Layout>
        <section style={{}}>
          <Landing />
        </section>

        <div id="trigger1" />
        <section style={{ background: "#f7f7f7", paddingBottom: "40px", paddingTop: "10px" }}>
          <section id="reveal1">
            <div style={{ textAlign: "center" }}>
              <Title>Focus Only on Results</Title>
              <img style={{ marginBottom: "20px" }} src="/hr.svg" />
            </div>
            <SubTitle>
              Tech driven Sourcing, Management of workforce ensures Speed & Quality of Work
              delivered
            </SubTitle>

            <UseCases />
          </section>
        </section>

        <div id="trigger2" />
        <section id="reveal2" style={{ paddingBottom: "40px", paddingTop: "10px" }}>
          <div style={{ textAlign: "center" }}>
            <Title>Scale Faster with 100,000+ Pre-Screened Freelancers</Title>
            <img style={{ marginBottom: "20px" }} src="/hr.svg" />
          </div>

          <Workers />
        </section>

        <div id="trigger3" />
        <section style={{ background: "#f7f7f7", paddingBottom: "40px", paddingTop: "10px" }}>
          <section id="reveal3">
            <div style={{ textAlign: "center" }}>
              <Title>Growing Every Single Second</Title>
              <img style={{ marginBottom: "20px" }} src="/hr.svg" />
            </div>

            <SubTitle>
              We thrive to keep expanding our platform to power your business with quality youth
              workforce so you can achieve speed, expand reach & save your time and resources.
            </SubTitle>

            <Counter />
          </section>
        </section>

        <div id="trigger4" />
        <section id="reveal4" style={{ paddingBottom: "40px", paddingTop: "10px" }}>
          <div style={{ textAlign: "center" }}>
            <Title>The most innovative companies use GigIndia</Title>
            <img style={{ marginBottom: "20px" }} src="/hr.svg" />
          </div>
          <SubTitle>
            They are experts in their fields, so are we. We help these brands seamlessly outsource
            their projects on a daily basis
          </SubTitle>

          <Trusts />

          <div style={{ textAlign: "center" }}>
            <Secondary
              style={{ marginTop: "10px" }}
              href="/customers"
              className="btn waves-effect waves-light white"
            >
              Show More
            </Secondary>
          </div>
        </section>

        <section style={{ background: "#f7f7f7", paddingBottom: "40px", paddingTop: "10px" }}>
          <div style={{ textAlign: "center" }}>
            <Title>We change lives of a lot of youth</Title>
            <img style={{ marginBottom: "20px" }} src="/hr.svg" />
          </div>
          <section id="pinContainer">
            <div id="slideContainer">
              <section className="panel">
                <Card
                  className="panel"
                  body="GigIndia provides you with remarkable internships, chance to build skills and a source to earn your pocket money without going out of your comfort zone."
                  name="Pooja Singh"
                  college="Symbiosis College of Arts & Commerce"
                  imgurl="/student/Pooja.png"
                />
              </section>
              <section className="panel">
                <Card
                  className="panel"
                  body="GigIndia is one of the coolest app I have ever known, it has simple and fun tasks, it also has lots of Contests to show our talent & earn pocket money!"
                  name="
Kalpak Gowardipe"
                  college="Symbiosis Institute of Technology"
                  imgurl="/student/Kalpak.png"
                />
              </section>
              <section className="panel">
                <Card
                  className="panel"
                  body="GigIndia has truly succeeded in creating an awesome platform for freelancers to earn quick money, making them more independent than ever."
                  name="Parth Waghwani"
                  college="ISB&M School of Technology"
                  imgurl="/student/Parth.png"
                />
              </section>
            </div>
          </section>
          {/* <StudentSlider /> */}
        </section>

        <div id="trigger5" />
        <section id="reveal5" style={{ paddingBottom: "40px", paddingTop: "10px" }}>
          <div style={{ textAlign: "center" }}>
            <Title>Backed By</Title>
            <img style={{ marginBottom: "20px" }} src="/hr.svg" />
          </div>

          <Partner />
        </section>

        <div id="trigger6" />
        <section style={{ background: "#f7f7f7", paddingBottom: "40px", paddingTop: "10px" }}>
          <section id="reveal6">
            <div style={{ textAlign: "center" }}>
              <Title>In The Press</Title>
              <img style={{ marginBottom: "20px" }} src="/hr.svg" />
            </div>

            <PressSlider />
          </section>
        </section>

        <section style={{ paddingBottom: "40px", paddingTop: "10px" }}>
          <CTA
            title="The future of work is empowered, engaged, and everywhere"
            sub="Get Customised Curated Workforce For Your Business Today"
            cta="Get Started for Free"
          />
        </section>
      </Layout>
    </Base>
  );
};

export default Index;
